import React from "react";
import SectionTitle from "../../components/SectionTitle";
import { useSelector } from "react-redux";


const About = () => {
  const {loading, portFolioData} = useSelector((state)=>state.root);
  const {about} = portFolioData;
  const {skills,lottieUrl,description1,description2} = about;
  return (
    <div>
      <SectionTitle title="About" />
      <div className="flex w-full items-center sm:flex-col">
        <div className="h-[70vh] w-1/2 sm:w-full">
          <dotlottie-player
            src={lottieUrl}
            background="transparent"
            speed="1"
            loop
            autoplay
          ></dotlottie-player>
        </div>
        <div className="flex flex-col gap-5 w-1/2 sm:w-full">
          <p className="text-white">
          {description1 || ''}
          </p>
          <p className="text-white">
            {description2 || ''}
          </p>
        </div>
      </div>
      <div className="py-5">
      <SectionTitle title="Skills" />
        {/* <h1 className="text-secondary text-xl">
            Skills : 
        </h1> */}
        <div className="flex flex-wrap gap-10 mt-5">
        {skills.map((skill,index)=>{
            return (
            <div className="border border-tertiary py-3 px-10">
                <h1 className="text-white">{skill}</h1>
            </div>)
            
        })}
        </div>
        
      </div>
    </div>
  );
};

export default About;
